// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2n5CU","subheader":"ReorderModal_subheader__1U5us","listWrap":"ReorderModal_listWrap__2boqJ"};